import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import Header from "common/js/header/header.js";
import axios from 'axios'
import lstModules from 'common/json/lstModules.json';
import DeductionSlider from "./deductionsSlider"
import DeductionTable from "./deductionTable"
import "../css/payrollSetupCtrl.css"
var tokenid = localStorage.getItem('tokenid');
function PDeduction() {

  const [randNo, setRandNo] = useState(0)
  const [lstAllowance, setLstAllowance] = useState([])
  const [selRow, setSelRow] = useState()
  const [selObj, setSelObj] = useState({})
  const [deductId, setDeductId] = useState(0)
  useEffect(() => {
    // getAllowanceData(cbGetAllowanceData)

  }, []);

  function getSelData(param) {
    setSelObj(param)
    // console.log(param)
    setDeductId(param.deductionId)
  }

  const colgrp = (
    <colgroup>
      <col width="4%"></col>
      <col width="4%"></col>
      <col width="4%"></col>
      <col width="15%"></col>
    </colgroup>
  );
  function generateRandomNo() {
    var lRand = Math.floor(Math.random() * 999999);
    setRandNo(lRand)
  }

  function getSelData(param) {
    setSelObj(param)
    setDeductId(param.deductionId)
  }
  function addNew() {
    setSelRow(null)
    setSelObj({})
    setDeductId(0)
  }
  return (<div>
    <Header></Header>
    <ToastContainer autoClose={3000} hideProgressBar />
    <div className="col-sm-11 col-centered pull-left" style={{ paddingTop: '2%' }}>
      <div className="col-sm-8">
        <DeductionTable
          key={randNo}
          getSelData={getSelData}

        ></DeductionTable>
        <div className="col-xs-1" onClick={(e) => addNew()}><span id="addReadyId" title="Add" className="addIcon glyphicon glyphicon-plus-sign"></span>
        </div>
      </div>
      <div className="col-sm-4">
        <DeductionSlider
          key={deductId}
          deductObj={selObj}
          deductId={deductId}
          generateRandomNo={generateRandomNo}
        ></DeductionSlider>
      </div>

    </div>
  </div >)
}
export default PDeduction;
